import CardIcon from "./CardIcon";
import {cardInfo} from "../../res/dataServices/cardInfo";
import './payment.css'
import LinkText from "../../newStructure/component/navigation/link/LinkText";

const CardDisplay = ({ bank }) => {

    const cardNumberDisplay = "**** **** **** " + bank.CreditCardNumber.slice(-4);
    const expiryText = "Expires " + bank.CreditCardExpMM + "/" + bank.CreditCardExpYY.toString().slice(-2)

    const cardID = bank.CreditCardType?.identifier;
    const cardCode = cardID ? cardInfo.getCodeCaseInsensitive(cardID) : null;

    const chargeRate = bank.CreditCardSurchargeRate;
    const showChargeRate = Boolean(chargeRate && chargeRate > 0);

    return (
        <div className="saved-card">
            <CardIcon cardType={cardCode}/>
            <div className="saved-card-detail">
                <p className="card-heading">{cardNumberDisplay}</p>
                <p>{bank.A_Name}</p>
                <p className="card-expiry">{expiryText}</p>
                {showChargeRate &&
                    <>
                        <p className="charge">Charge Rate: {chargeRate}%</p>
                        <LinkText className="clickable-text" href="/account/helpDesk/getHelp/Why am I being charged for using a business card">Whats this?</LinkText>
                    </>
                }
            </div>
        </div>
    )

}

export default CardDisplay;
